import { render } from "./CreateOrderWithoutPayment.vue?vue&type=template&id=25365564"
import script from "./CreateOrderWithoutPayment.vue?vue&type=script&lang=js"
export * from "./CreateOrderWithoutPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__